import $ from 'jquery';
import AbstractController from './AbstractController';
import Controller from './Controller';
import { $html } from '../constants';

// Utility
import HelperUtility from '../Utility/HelperUtility';

// Service
import HeadlineService from '../Service/HeadlineService';

// HtmlElements
import Banner from '../Elements/Banner';
import BannerCta from '../Elements/BannerCta';
import Header from '../Elements/Header';
import NavSubHorizontal from '../Elements/NavSubHorizontal';
import BackToTopButton from '../Elements/BackToTopButton';
import ContentSlider from '../Elements/ContentSlider';
import ImageSlider from '../Elements/ImageSlider';
import Videos from '../Elements/Videos';
import Form from '../Elements/Form';
import CtaBar from '../Elements/CtaBar';
import NavMain from '../Elements/NavMain';
import MetaBar from '../Elements/MetaBar';
import FileUpload from '../Elements/FileUpload';

/**
 * Controller for this page
 * Handles page flow and special HtmlElements
 *
 * @class
 */
class PageController extends AbstractController {

  /**
   * @constructor
   */
  constructor() {
    super();

    Controller.registerController(this);

    // Object containing special elements that inherit from HtmlElement
    // relevant page events are delegated to these objects through the controller
    this._registerElements(
      Banner,
      BannerCta,
      Header,
      NavSubHorizontal,
      BackToTopButton,
      ...ContentSlider,
      ...ImageSlider,
      ...Videos,
      ...Form,
      CtaBar,
      NavMain,
      MetaBar,
      ...FileUpload
    );

    // Initialize HeadlineService
    HeadlineService.initialize();
  }

  // Private

  /**
   * Checks if equalized rows contain boxes
   *
   * @return void
   */
  _checkRowsContainsBox() {
    let $rows = $('.row.equalized');

    $rows.each((i, el) => {
      let $row = $(el),
        $columns = $row.find('> .columns');

      $columns.each((i, el) => {
        let $box = $(el).find('.box');

        if ($box.length) {
          $row.addClass('contains-box');
        }
      });
    });
  }

  /**
   * Adds the javascript for accordions
   *
   * @return void
   */
  _addAccordionJavascript() {
    $('[data-accordion]').each(function () {
      if ($(this).data('accordion') !== '') {
        let $accordion = $(this);

        if ($(this).data('multi-expand') != 'true') {
          $(this).find('.accordion-item > a').on('click', function () {
            let $clickedAccordionItem = $(this).parent('.accordion-item');

            $('[data-accordion="' + $accordion.data('accordion') + '"]').each(function () {
              let $curAccordion = $(this);

              $curAccordion.find('.accordion-item').not($clickedAccordionItem).each(function () {
                $curAccordion.foundation('up', $(this).find('.accordion-content'));
              });
            });
          });
        }
      }
    });
  }

  // Public

  /**
   * Handles ready event
   *
   * @return void
   */
  onReady() {
    super.onReady();

    $html.attr('data-touch-device', HelperUtility.isTouchDevice());

    if (!HelperUtility.supportsCssFilter()) {
      $html.addClass('no-css-filter');
    }

    this._checkRowsContainsBox();
    this._addAccordionJavascript();
  }
}

export default (new PageController);
